<div class="table-responsive animated fadeIn slow">
    <div>
        <h2 class="titulo text-center">REPORTES DE PLANTILLA DEL PERSONAL</h2>
    </div>

    <!-- FILTROS -->
    <div class="filtros-wrapper" style="display:flex;gap:1rem;flex-wrap:wrap;margin-bottom:1rem;">

        <!-- SELECT PLANTELES -->
        <div class="filtro">
            <label>Plantel</label>
            <select class="input-clean" [(ngModel)]="plantelSeleccionado">
        <option [value]="0">Dirección General</option>
        <option [value]="-1">Todos</option>
        <option *ngFor="let p of planteles" [value]="p.idplantel">{{ p.nombreplantel }}</option>
      </select>
        </div>

        <!-- INPUT NOMBRE -->
        <div class="filtro">
            <label>Buscar por nombre</label>
            <input type="text" class="input-clean" placeholder="Escribe nombre o apellido..." [(ngModel)]="filtroNombre">
        </div>

        <!-- BOTÓN BUSCAR -->
        <div class="filtro filtro-boton" style="display:flex;align-items:flex-end;">
            <button class="btn-accent" (click)="buscarReportes()">
        <i class="fas fa-search"></i> Buscar
      </button>
        </div>

    </div>

    <!-- BOTONES EXCEL -->
    <div class="excel-wrapper" style="display:flex;gap:.5rem;align-items:center;margin-top:1rem;">
        <button class="btn-excel" (click)="exportPlantillaempleadofXLSX()">
      <i class="fas fa-file-excel"></i> Descargar todo (plantilla cargada)
    </button>

        <button class="btn-excel" (click)="exportPlantillaFiltradaXLSX()">
      <i class="fas fa-file-excel"></i> Descargar filtrado
    </button>
    </div>

    <!-- TABLA: SOLO SI YA BUSCÓ Y HAY RESULTADOS -->
    <div class="table-responsive mt-4" *ngIf="yaBusco && resultados.length > 0">
        <div class="resultados-count">
            {{ resultados.length }} resultados encontrados
        </div>

        <table class="tabla-asignaturas">
            <thead>
                <tr>
                    <th>Nombre completo</th>
                    <th>Núm. empleado</th>
                    <th>RFC</th>
                    <th>CURP</th>
                    <th>Plaza</th>
                    <th>Tipo</th>
                    <th>Puesto</th>
                    <th>Correo</th>
                    <th>Estatus</th>
                </tr>
            </thead>

            <tbody>
                <tr *ngFor="let p of resultados">
                    <td>{{ p["Nombre completo"] }}</td>
                    <td>{{ p["Número de empleado"] }}</td>
                    <td>{{ p["RFC"] }}</td>
                    <td>{{ p["CURP"] }}</td>
                    <td>{{ p["Plaza"] }}</td>
                    <td>{{ p["Tipo de trabajador"] }}</td>
                    <td>{{ p["Puesto"] }}</td>
                    <td>{{ p["Correo institucional"] }}</td>
                    <td>{{ p["Estatus"] }}</td>
                </tr>
            </tbody>
        </table>
    </div>

    <!-- MENSAJE: YA BUSCÓ PERO NO HAY RESULTADOS -->
    <div *ngIf="yaBusco && resultados.length === 0" style="margin-top:1rem;">
        <small>No hay resultados para los filtros seleccionados.</small>
    </div>
</div>